import selectInsurance from 'utils/selectInsurance';
import getPatientGender from 'utils/print/getPatientGender';

const getInsuranceInsuredsGender = ({ patient, insurance, value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  if (selectedInsuranceRelationToInsured === 'Self') {
    return getPatientGender({
      ...otherProps,
      patient,
      insurance,
    });
  }

  return null;
};

export default getInsuranceInsuredsGender;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsGender.js